<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('options_categories.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openOptionsCategoryForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetOptionsCategories(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="options_categories" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openOptionsCategoryForm(props.item)">
                                <td>{{ props.item.category_id }}</td>
                                <td>{{ props.item.category }}</td>
                                <td>{{ props.item.system_list }}</td>
                                <td>
                                    <v-chip round text-color="white" class="mr-auto fs-14" color="green">
                                        <span class="white--text">{{ props.item.status == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="options_categories"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="options_category_dialog">
                <v-card>
                    <v-form ref="form_options_category">
                        <v-card-title>
                            <span class="headline">{{
                                options_category.category_id ? $t("lang.edit_options_category") : $t("lang.add_options_category")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeOptionsCategoryDialog"
                                :dialog-status="options_category_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="options_category.category"
                                            :label="`${$t('lang.category')} *`"
                                            :counter="showCounter(options_category.category, 'options_categories.category')"
                                            :rules="ifValid('options_categories.category')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="options_category.system_list"
                                            :label="`${$t('lang.system_list')} *`"
                                            :rules="ifValid('options_categories.system_list')"
                                        ></v-switch>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="options_category.status"
                                            :label="`${$t('lang.status')} *`"
                                            :rules="ifValid('options_categories.status')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="options_category.category_id" color="error" @mouseup.left="$refs.delete_options_categories.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeOptionsCategoryDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveOptionsCategories">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_options_categories"
                :heading="$t('lang.delete_options_category')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteOptionsCategories(options_category.category_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openOptionsCategoryForm" },
                { title: this.$t("lang.refresh"), action: "dbGetOptionsCategories", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.category_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.category"), sortable: false, width: "25%" },
                { text: this.$t("lang.system_list"), sortable: false, width: "25%" },
                { text: this.$t("lang.status"), sortable: false, width: "25%" },
            ],
            enableAddModal: true,
            enableEditModal: false,
            options_category: {},
            filter: {
                search: "",
                status: "1",
            },
            options_category_dialog: false,
            dbGetOptionsCategories: _.debounce(this.getOptionsCategories, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchOptionsCategories", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.options_categories) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchOptionsCategories({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.options_categories) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.options_categories.options_categories_filter,
            page: (state) => state.options_categories.page,
            rules_options_categories: (state) => state.options_categories.rules_options_categories,
            options_category_status_options: (state) => state.settings.options_category_status_options,
            options_categories: (state) => state.options_categories.options_categories,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchOptionsCategories", "saveOptionsCategory", "deleteOptionsCategory"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openOptionsCategoryForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_options_category) item ? this.$refs.form_options_category.resetValidation() : this.$refs.form_options_category.reset();

                    this.$nextTick(() => {
                        this.options_category = item != null ? this.assignObj2(item, this.rules_options_categories) : {};
                        this.options_category_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "options_category", params: { id: item.category_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_options_category) item ? this.$refs.form_options_category.resetValidation() : this.$refs.form_options_category.reset();
                    this.options_category_dialog = true;
                } else {
                    this.$router.push({ name: "options_category" });
                }
            }
        },
        saveOptionsCategories() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_options_category")) {
                    let body = this.prepForm(this.options_category, this.rules_options_categories);

                    this.saveOptionsCategory({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getOptionsCategories();
                                this.closeOptionsCategoryDialog();
                            } else {
                                this.$router.push({ name: "options_category", params: { id: data.options_category.category_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteOptionsCategories(id = null) {
            this.deleteOptionsCategory({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getOptionsCategories();
                    this.closeOptionsCategoryDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeOptionsCategoryDialog() {
            this.options_category_dialog = false;
            this.$refs.delete_options_categories.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getOptionsCategories(pg_refresh = false) {
            this.startLoader();

            this.fetchOptionsCategories({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.options_category_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });

            this.finishLoader();
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
};
</script>
